import { ProductFullDeatilViewModel, ProductListWordpress } from "@payping/api";
import { CLEAR_LIST, LOGGED_OUT } from "./constants";
import { ClearListAction, LoggedOutAction } from "./types";

export const PRODUCTS_LOADED = "PRODUCTS_LOADED";
export const SET_PRODUCT_DETAILS = "SET_PRODUCT_DETAILS";
export const PRODUCT_REMOVED = "PRODUCT_REMOVED";
export const TOGGLE_PRODUCT_ACTIVATION = "TOGGLE_PRODUCT_ACTIVATION";
export const TOGGLE_PRODUCT_ARCHIVE = "TOGGLE_PRODUCT_ARCHIVE";

export interface ProductState {
  list: ProductListWordpress[];
  totalCount: number;
  paginationEnd: boolean;
  details?: ProductFullDeatilViewModel;
}

export interface ProductsLoadedAction {
  type: typeof PRODUCTS_LOADED;
  payload: { list: ProductListWordpress[]; totalCount: number; append: boolean };
}

export interface SetProductDetailsAction {
  type: typeof SET_PRODUCT_DETAILS;
  payload: { details: ProductFullDeatilViewModel };
}

export interface ProductRemovedAction {
  type: typeof PRODUCT_REMOVED;
  payload: { code: string };
}

export interface ToggleProductActivationAction {
  type: typeof TOGGLE_PRODUCT_ACTIVATION;
  payload: { code: string };
}

export interface ToggleProductArchiveAction {
  type: typeof TOGGLE_PRODUCT_ARCHIVE;
  payload: { code: string };
}

export type ProductActionTypes =
  | ProductsLoadedAction
  | SetProductDetailsAction
  | ProductRemovedAction
  | ToggleProductActivationAction
  | ToggleProductArchiveAction
  | ClearListAction
  | LoggedOutAction;

const initialState: ProductState = {
  details: undefined,
  list: [],
  paginationEnd: false,
  totalCount: 0,
};

export default function products(state = initialState, action: ProductActionTypes): ProductState {
  if (action.type === PRODUCTS_LOADED) {
    const { list, totalCount, append } = action.payload;
    const newList = append ? [...state.list, ...list] : list;
    return {
      ...state,
      list: newList,
      paginationEnd: !list.length || newList.length >= totalCount,
      totalCount,
    };
  }

  if (action.type === SET_PRODUCT_DETAILS) {
    const { details } = action.payload;
    return {
      ...state,
      details,
    };
  }

  if (action.type === PRODUCT_REMOVED) {
    const { code } = action.payload;
    const list = state.list.filter((item) => item.code !== code);
    const details = state.details && state.details.code === code ? initialState.details : state.details;
    const totalCount = state.totalCount - 1;

    return {
      ...state,
      details,
      list,
      totalCount,
    };
  }

  if (action.type === TOGGLE_PRODUCT_ACTIVATION) {
    const { code } = action.payload;
    const list = state.list.map((item) => {
      if (item.code === code) {
        return {
          ...item,
          ...(typeof item.isActive === "boolean" ? { isActive: !item.isActive } : {}),
        };
      }
      return item;
    });
    const details =
      state.details && state.details.code === code
        ? { ...state.details, isActive: !state.details.isActive }
        : state.details;

    return {
      ...state,
      details,
      list,
    };
  }

  if (action.type === TOGGLE_PRODUCT_ARCHIVE) {
    const { code } = action.payload;
    const itemInList = state.list.find((item) => item.code === code);
    let { list } = state;
    let { details } = state;
    if (itemInList) {
      list = list.filter((item) => item.code !== code);
    } else if (state.details && state.details.code === code) {
      details = { ...state.details, isArchived: !state.details.isArchived };
      list = [details, ...list];
    }

    return {
      ...state,
      details,
      list,
    };
  }

  if (action.type === CLEAR_LIST) {
    return {
      ...state,
      list: [],
    };
  }

  if (action.type === LOGGED_OUT) {
    return initialState;
  }

  return state;
}
